import React, { useState, useEffect, useContext } from 'react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { UsuarioInterface } from '../../../ImportBackend/Interfaces/UsuarioInterfaces'
import Condicional from '../../../Layout/Condicional'
import { StatusForm } from './Usuarios'
import CloseIcon from '@mui/icons-material/Close'
import ShowText from '../../../DevComponents/ShowText'
import BackEndAPI from '../../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import { MensagemTipo } from '../../../GlobalStates/MensagemState'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import SearchText from '../../../DevComponents/SearchText'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'
import Typography from '@mui/material/Typography'
import { ClienteInterface } from '../../../ImportBackend/Interfaces/ClienteInterfaces'

interface PropsInterface {
  statusForm: StatusForm
  dados: UsuarioInterface
  clsApi: BackEndAPI
  onCancelar: () => void
}

export default function UsuariosClientes ( { clsApi, statusForm, dados, onCancelar }: PropsInterface ) {

  const [rsClientes, setRsClientes] = useState<Array<ClienteInterface>>( [] )

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'nomeFantasia',
      cabecalho: 'Nome Fantasia',
      alinhamento: 'left'
    },
    {
      campo: 'razaoSocial',
      cabecalho: 'Razão Social',
      alinhamento: 'left'
    }
  ]

  const btExcluirCliente = ( grupo: ClienteInterface ) => {

    const mutation = `
        excluirClienteUsuario(idUsuario: ${dados.idUsuario}, idCliente: ${grupo.idCliente}) {
          ok
          mensagem
        }
      `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'excluirClienteUsuario', 'Excluindo Cliente...', contexto ).then( rs => {

      if ( rs.ok ) {

        pesquisarUsuarioClientes()

      } else {

        setMensagemState( {
          ...mensagemState,
          exibir: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      }

    } )

  }

  const pesquisarUsuarioClientes = () => {
    const query = `
      getUsuarioClientesPermitidosPorIdUsuario(idUsuario: ${dados.idUsuario}) {
        idCliente
        razaoSocial
        nomeFantasia
      }
    `

    clsApi.query<Array<ClienteInterface>>( query, 'getUsuarioClientesPermitidosPorIdUsuario', 'Recebendo Clientes...', contexto ).then( rsClientes => {

      setRsClientes( rsClientes )

    } ).catch( () => {

      setMensagemState( {
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Consultar Clientes de Usuários!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

    } )
  }

  useEffect( () => {

    if ( [StatusForm.EditandoClientes].includes( statusForm ) ) {

      pesquisarUsuarioClientes()

    }

    //eslint-disable-next-line
  }, [dados, statusForm] )

  const [novoCliente, setNovoCliente] = useState<ClienteInterface | null>( null )

  const novoClienteSelecionado = ( v: ClienteInterface | null ) => {

    setNovoCliente( v )

    if ( v ) {

      const mutation = `
        incluirClienteUsuario(idUsuario: ${dados.idUsuario}, idCliente: ${v.idCliente}) {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>( mutation, 'incluirClienteUsuario', 'Incluindo Cliente...', contexto ).then( rs => {

        if ( rs.ok ) {

          pesquisarUsuarioClientes()

        } else {

          setMensagemState( {
            ...mensagemState,
            exibir: true,
            mensagem: rs.mensagem,
            tipo: MensagemTipo.Error,
            exibirBotao: true
          } )

        }

      } )

    }

  }

  return (
    <>
      <Condicional condicao={[StatusForm.EditandoClientes].includes( statusForm )}>
        <Grid item xs={12}>
          <ShowText dados={dados} field='nome' label='Nome' />
        </Grid>

        <Grid item xs={12}>

          <SearchText
            onChange={novoClienteSelecionado}
            objQuery='{idCliente, razaoSocial}'
            campoPesquisa='razaoSocial'
            campoID='idCliente'
            label='Adicionar Cliente'
            value={novoCliente}
            mensagemQuery='Procurando Clientes...'
            campoQuery='pesquisa'
            nomeQuery='getClientes'
          />

        </Grid>

        <Grid item xs={12} sx={{ mt: 3 }}>

          <Typography component="h6" variant="h6" align="left">
            Clientes Ativos Para Este Usuário
          </Typography>

          <DataTable
            dados={rsClientes}
            cabecalho={Cabecalho}
            acoes={[{ icone: 'delete', toolTip: 'Cancelar Acesso', onAcionador: btExcluirCliente }]}
          />

        </Grid>

        <Grid item xs={12} sx={{ mt: 3, textAlign: 'right' }}>

          <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => onCancelar()}>Cancelar</Button>

        </Grid>

      </Condicional>
    </>
  )

}